import { makeAutoObservable } from 'mobx';
import { UserModel } from '../models/user';
import { ScreenRecording } from '../interfaces/app';
import { UniversalSearchData } from '../interfaces/comment';

export class AppStore {
  extractedDesktopView: number = 0;
  isPageScrolled: boolean = false;
  screenRecordingLoading: boolean = false;
  screenRecordingUrl: string = '';
  isNavbarShow: boolean = true;
  isAppLoading: boolean = false;
  customBranding: any = {};
  userModalDetail: UserModel | null = null;
  isBubbleMenuOpen: boolean = false;
  snapList: ScreenRecording[] = [];
  universalSearchData: UniversalSearchData | null = null;
  authLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  //Updates the extracted desktop view value
  setExtractedDesktopView(extractedDesktopView: number) {
    this.extractedDesktopView = extractedDesktopView;
  }

  // Updates the page scroll state
  setIsPageScrolled(isPageScrolled: boolean) {
    this.isPageScrolled = isPageScrolled;
  }

  setScreenRecordingLoading(screenRecordingLoading: boolean) {
    this.screenRecordingLoading = screenRecordingLoading;
  }

  setScreenRecordingUrl(screenRecordingUrl: string) {
    this.screenRecordingUrl = screenRecordingUrl;
  }

  //set is navbar show
  setIsNavbarShow(isNavbarShow: boolean) {
    this.isNavbarShow = isNavbarShow;
  }

  // Updates the application loading state
  setIsAppLoading(isAppLoading: boolean) {
    this.isAppLoading = isAppLoading;
  }

  //set custom branding
  setCustomBranding(customBranding: any) {
    this.customBranding = customBranding;
  }

  //set user modal detail
  setUserModalDetail(userModalDetail: UserModel) {
    this.userModalDetail = userModalDetail;
  }

  setIsBubbleMenuOpen(isBubbleMenuOpen: boolean) {
    this.isBubbleMenuOpen = isBubbleMenuOpen;
  }

  setSnapList(snaps: ScreenRecording[]) {
    this.snapList = snaps;
  }

  setUniversalSearchData(universalSearchData: UniversalSearchData) {
    this.universalSearchData = universalSearchData;
  }

  setAuthLoading(authLoading: boolean) {
    this.authLoading = authLoading;
  }

  //Clear app related data
  clearAppData() {
    this.snapList = [];
    this.universalSearchData = null;
    this.screenRecordingUrl = '';
    this.isPageScrolled = false;
  }
}
